import React from "react";
import { useEffect } from "react";
import avatar from "../../images/avatar.png";
import arrow from "../../images/arrow.png";
import Table from "../partials/table";
import Faq from "../partials/faq";
import Footer from "../partials/footer";
import Nav from "../partials/nav";
import { useMediaQuery } from "../../hook/usemediaquery";
import { MobileNav } from "../partials/mobile-nav";

const Landing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const matches = useMediaQuery("(min-width: 768px)");
  return (
    <div>
      {matches ? <Nav></Nav> : <MobileNav/>}

      <div>
        <div className="landing-row">
          <div className="col-lg-12">
            <h3 className="main-header">
              <span>Start winning </span> today: <span> copy </span>expert bet
              code now!
            </h3>
            {/* <h3 className="main-header2"></h3> */}
            <p className="hero-intro">
              Get Ahead with Cuppycode: Your One-Stop Destination
              <br /> for Winning Betting Codes!
            </p>
            <p className="hero-intro2">
              Get Ahead with Cuppycode: Your One-Stop
              <br /> Destination for Winning Betting Codes!
            </p>
            <img src={arrow} className="img-fluid arrow" alt="arrow" />
            <img src={avatar} className="img-fluid avatar" alt="avatar" />
          </div>
        </div>
      </div>

      <Table></Table>
      <Faq></Faq>
      <Footer></Footer>
    </div>
  );
};

export default Landing;
